module.exports = __webpack_public_path__ + "img/18_93.ff830994.png";